import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { projectCreatePermissionsResource } from '@atlassian/jira-router-resources-project-permissions/src/services/project-permissions/index.tsx';
import { polarisUnlicensedRoute } from '@atlassian/jira-router-routes-polaris-routes/src/polarisUnlicensedRoute.tsx';
import UnlicensedPage, { LazyUnlicensedPage } from './ui/unlicensed/index.tsx';

export const polarisUnlicensedRouteEntry = createEntry(polarisUnlicensedRoute, () => ({
	isStrictModeEnabled: false,
	group: 'polaris',
	component: UnlicensedPage,
	layout: globalLayout,
	canTransitionIn: () => true,
	resources: [...getNavigationResources(), projectCreatePermissionsResource],
	forPaint: [LazyAtlassianNavigation, LazyUnlicensedPage],
}));
